import axios from 'axios';

jQuery(document).ready(function () {
    if (jQuery('#engagement').length > 0) {
        const hash = getParam('engagement');
        getEngagement(hash);
    }
});

jQuery('#listengagement .left .single').click(function () {
    const id = jQuery(this).data('id');
    getEngagement(id);
});

const getEngagement = (id) => {
    axios.get(`/wp-json/wp/v2/engagements/${ id }`)
        .then(function (response) {
            // handle success
            const data = response.data;
            jQuery('#listengagement .right h2').text(data.title.rendered);
            jQuery('#listengagement .right .secondcontent').html(data.content.rendered);
        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
        .then(function () {
            // always executed
        });
}

const getParam = (param) => {
    const vars = {};
    window.location.href.replace(location.hash, '').replace(
        /[?&]+([^=&]+)=?([^&]*)?/gi, // regexp
        function ( m, key, value ) {
        // callback
            vars[key] = value !== undefined ? value : '';
        }
    );

    if ( param ) {
        return vars[param] ? vars[param] : null;
    }

    return vars;
}


// WEBPACK FOOTER //
// ./src/js/app/engagement.js